export default {"src":"/_next/static/media/starEmpty.f63110e9.svg","height":20,"width":21};